__turbopack_context__.v({
  "agreement_block": "ffL4wq_agreement_block",
  "content_box": "ffL4wq_content_box",
  "grid_block": "ffL4wq_grid_block",
  "icon_btn": "ffL4wq_icon_btn",
  "main_wrapper": "ffL4wq_main_wrapper",
  "question_layout": "ffL4wq_question_layout",
  "question_layout_wrapper": "ffL4wq_question_layout_wrapper",
});
